import { render } from "./DashboardCard.vue?vue&type=template&id=9a465ff4&scoped=true"
import script from "./DashboardCard.vue?vue&type=script&lang=js"
export * from "./DashboardCard.vue?vue&type=script&lang=js"

import "./DashboardCard.vue?vue&type=style&index=0&id=9a465ff4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a465ff4"]])

export default __exports__